/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserAvailabilityDto
 */
export interface UserAvailabilityDto {
    /**
     * 
     * @type {number}
     * @memberof UserAvailabilityDto
     */
    iduserAvailability?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAvailabilityDto
     */
    iduser?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAvailabilityDto
     */
    idavailability?: number;
    /**
     * 
     * @type {Date}
     * @memberof UserAvailabilityDto
     */
    jour?: Date;
}

/**
 * Check if a given object implements the UserAvailabilityDto interface.
 */
export function instanceOfUserAvailabilityDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserAvailabilityDtoFromJSON(json: any): UserAvailabilityDto {
    return UserAvailabilityDtoFromJSONTyped(json, false);
}

export function UserAvailabilityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAvailabilityDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iduserAvailability': !exists(json, 'iduserAvailability') ? undefined : json['iduserAvailability'],
        'iduser': !exists(json, 'iduser') ? undefined : json['iduser'],
        'idavailability': !exists(json, 'idavailability') ? undefined : json['idavailability'],
        'jour': !exists(json, 'jour') ? undefined : (new Date(json['jour'])),
    };
}

export function UserAvailabilityDtoToJSON(value?: UserAvailabilityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iduserAvailability': value.iduserAvailability,
        'iduser': value.iduser,
        'idavailability': value.idavailability,
        'jour': value.jour === undefined ? undefined : (value.jour.toISOString()),
    };
}

